import React from "react";
import PropTypes from "prop-types";
import PrimaryLink from "../../elements/primary-link";
import "./style.scss";

const MembershipPayment = ({ paymentDetails }) => {
  return (
    <div className="membership-payment">
      <div className="membership-payment-header">
        <div className="label">{paymentDetails?.nextPayment?.heading?.title}</div>
        <div className="value">{paymentDetails?.nextPayment?.heading?.value}</div>
      </div>
      <div className="membership-payment-details">
        {(paymentDetails?.nextPayment?.items || []).map((item, index) => {
          return (
            <div className="membership-payment-row" key={index}>
              <div className="label">{item.title}</div>
              <div className="value">{item.value}</div>
            </div>
          );
        })}
      </div>
      {paymentDetails?.summary && (
        <div className="membership-payment-summary">
          {(paymentDetails.summary.items || []).map((item, index) => {
            return (
              <div className="membership-payment-row" key={index}>
                <div className="label">{item.title}</div>
                <div className="value">{item.value}</div>
              </div>
            );
          })}
        </div>
      )}
      <div className="update-payment-method">
        <PrimaryLink {...paymentDetails.link} />
      </div>
    </div>
  );
};

MembershipPayment.propTypes = {
  paymentDetails: PropTypes.shape({
    nextPayment: PropTypes.shape({
      heading: PropTypes.shape({
        title: PropTypes.string,
        body: PropTypes.string
      }),
      items: PropTypes.array
    }),
    summary: PropTypes.shape({
      items: PropTypes.array
    }),
    link: PropTypes.object
  })
};

export default MembershipPayment;
